import { createBIEvent } from '@wix/editor-elements-preview-utils/bi';

const addressSelect = createBIEvent({ src: 5, evid: 1363, fields: {} });

export default {
  addressSelect,
};
